export const SEARCH_PLACEHOLDER_TEXT = "Ask a question..." as const;
export const CHAT_PLACEHOLDER_TEXT = "Ask anything..." as const;
export const MAX_MESSAGE_LENGTH = 150;
export const COLLAPSED_CONTENT_HEIGHT = 200;
